import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Paginator } from '../../../interfaces/paginator.interface'

@Component({
    selector: 'case-meta',
    templateUrl: './meta.component.html',
    styleUrls: ['./meta.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class MetaComponent {
  @Input() paginator: Paginator<any>
}
